(function () {
  let prevWindowWidth = window.innerWidth;
  let prevScrollTop = 0;

  //intro sticky scroll
  const scrollAnimate = (function scrollAnimate() {
    const root = document.querySelector(".ap-section--intro");
    const targetItems = root.querySelectorAll(".story__item");
    let animateIn = null;

    function init() {
      ScrollTrigger.getAll().forEach((ST) => ST.kill());
      targetItems.forEach(function (item, index) {
        const conWrap = item.querySelector(".con-wrap");

        const text = item.querySelector(".ap-text-wrap");
        const textchild = text.childNodes;

        const dim = item.querySelector(".dim");

        animateIn = gsap.timeline({
          scrollTrigger: {
            trigger: conWrap,
            pin: conWrap,
            scrub: true,
            start: "top bottom",
            end: "center bottom",
            // markers: true,
          },
        });

        animateIn.fromTo(
          dim,
          { opacity: 0 },
          {
            ease: "power1.in",
            opacity: 1,
          },
          "bg"
        );

        textchild.forEach((e) => {
          animateIn.fromTo(
            e,
            { opacity: 0, y: "50%" },
            {
              ease: "power1.in",
              opacity: 1,
              y: 0,
            },
            "bg"
          );
        });
      });
    }

    function resize() {
      ScrollTrigger.getAll().forEach((ST) => ST.kill());
      init();
    }

    return {
      init: init,
      resize: resize,
    };
  })();

  // photo wall
  //240104 이미지 랜덤노출 비활성화
  // const photoWall = (function photoWall() {
  //   function init() {
  //     const imageHost = `/jp/ja/resource/image/library/2023/rouge_classy_story_glitch_img_jp_240103_`;
  //     const glitchContainers = document.querySelectorAll(".glitch");

  //     // random images
  //     function getRandomNumber() {
  //       let randomIndexArray = [];
  //       for (let i = 0; i < 26; i++) {
  //         let randomNum = Math.floor(Math.random() * 26 + 1);
  //         if (randomIndexArray.indexOf(randomNum) === -1) {
  //           randomIndexArray.push(randomNum);
  //         } else {
  //           i--;
  //         }
  //       }
  //       return randomIndexArray;
  //     }
  //     const num = getRandomNumber();

  //     glitchContainers.forEach((container, containerIndex) => {
  //       const glitchImages = container.querySelectorAll(".glitch__img");
  //       const firstImageIndex = num[containerIndex] - 1;

  //       glitchImages.forEach((glitchImg, imgIndex) => {
  //         const imageUrl = imageHost + firstImageIndex + ".jpg";
  //         glitchImg.style.setProperty("--image", `url(${imageUrl})`);
  //       });
  //     });
  //   }
  //   return {
  //     init: init,
  //   };
  // })();

  // animationOnScroll
  const animationOnScroll = (function () {
    const targetSelector = "[data-io]";
    const addClassName = "io-animation";

    function init() {
      const io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            const isParent = e.target.parentNode.dataset.ioParent;
            const target = isParent ? item.parentNode : e.target;

            const isIntersecting = e.isIntersecting;
            if (isIntersecting) {
              if (!target.classList.contains(addClassName)) {
                target.classList.add(addClassName);
              }
            } else {
              target.classList.remove(addClassName);
            }
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        }
      );
      const ioElements = document.querySelectorAll(targetSelector);
      ioElements.forEach(function (item) {
        const hasParent = item.parentNode.dataset.ioParent;
        const target = hasParent ? item.parentNode : item;

        io.observe(target);
      });
    }

    return {
      init: init,
    };
  })();

  animationOnScroll.init();
  // photoWall.init();
  scrollAnimate.init();

  document.addEventListener("readystatechange", (event) => {
    if (event.target.readyState === "complete") {
      scrollAnimate.init();
    }
  });

  window.addEventListener("resize", function () {
    const scrollTop = window.yPos || window.pageYOffset;

    if (scrollTop >= prevScrollTop) {
      scrollDirection = "down";
    } else {
      scrollDirection = "up";
    }
    prevScrollTop = scrollTop;

    if (prevWindowWidth !== window.innerWidth) {
      scrollAnimate.resize();
    }

    prevWindowWidth = window.innerWidth;
  });
})();
